import React from 'react';
import PropTypes from 'prop-types';
import DeleteSection from './DeleteSection/DeleteSection';
import ConfigSection from './ConfigSection/ConfigSectionContainer';

const propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
  deleteInstance: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  settings: PropTypes.shape({}).isRequired,
  serviceSubtype: PropTypes.string.isRequired,
};

export function UnstyledSettingsTab({ id, service, serviceSubtype, settings, ...props }) {
  return (
    <React.Fragment>
      <ConfigSection
        id={id}
        service={service}
        instanceSettings={settings}
        serviceSubtype={serviceSubtype}
      />

      <DeleteSection id={id} service={service} {...props} />
    </React.Fragment>
  );
}

UnstyledSettingsTab.propTypes = propTypes;

export default UnstyledSettingsTab;
